export default __webpack_public_path__ + "static/media/Club-Apparel.c694c45b.jpg";